import axios from './config'

export const SERVER_URL = (import.meta.env.MODE === 'development') ? '/api' : 'https://server.pptist.cn'
export const ASSET_URL = '/mocks'

export default {
  getMockData(filename: string): Promise<any> {
    return axios.get(`./mocks/${filename}.json`)
  },

  getFileData(filename: string): Promise<any> {
    return axios.get(`${ASSET_URL}/${filename}.json`)
  },

  AIPPT_Outline(content: string, language: string): Promise<any> {
    return fetch(`${SERVER_URL}/tools/aippt_outline`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        content,
        language,
        stream: true,
      }),
    })
  },

  AIPPT(content: string, language: string) {
    return axios.post(`${SERVER_URL}/tools/aippt`, { content, language })
  },
}
